export const HSOptions = {
    user: {
        accountStatus: [
            {
                label: 'Inactive',
                value: 'Inactive'
            }, {
                label: 'Active',
                value: 'Active'
            }, {
                label: 'Not Validated',
                value: 'NotValidated',
                disabled: true
            }, {
                label: 'Deleted',
                value: 'Deleted',
                disabled: true
            },
        ],
        media: {
            status: [{
                label: 'Active',
                value: 'Active'
            }, {
                label: 'Inactive',
                value: 'Inactive'
            }],
            types: [{
                label: 'License Plate',
                value: 'LicensePlate'
            }, {
                label: 'RFID',
                value: 'RFID'
            }],
            tags: [{
                label: 'Hamilton',
                value: 'Hamilton'
            }, {
                label: 'XPress Wash',
                value: 'XpresWash'
            }]
        },
        recurringBilling: [{
            label: 'Automatic',
            value: 'Automatic'
        }, {
            label: 'Manual',
            value: 'Manual'
        }]
    },
    kioskItems: {
        types: [
            {
                label: 'Wash',
                value: 'Wash'
            },
            {
                label: 'Bundle Codes',
                value: 'CodeBundle'
            },
        ]
    },
    expressPass: {
        status: [
            {
                label: 'Inactive',
                value: 'Inactive'
            }, {
                label: 'Active',
                value: 'Active'
            }
        ],
        maxUsePeriod: [
            {
                label: 'Unlimited',
                value: 'Unlimited'
            }, {
                label: 'Day',
                value: 'Day'
            }, {
                label: 'Month',
                value: 'Month'
            },
        ],
        receiptMode: [
        {
                label: 'Kiosk Default',
                value: 'KioskDefault'
            }, {
                label: 'Ask',
                value: 'Ask'
            }, {
                label: 'Always',
                value: 'Always'
            }, {
                label: 'Never',
                value: 'Never'
            },
        ],
        awardType: [
            {
                label: 'Item',
                value: 'ItemRate'
            }, {
                label: 'Transaction Dollar Discount',
                value: 'DollarDiscTrans'
            }, {
                label: 'Item Dollar Discount',
                value: 'DollarDiscItem'
            },
        ],
        awardItemType: [
            {
                label: 'Item',
                value: 'Item'
            }, {
                label: 'Transaction Dollar Discount',
                value: 'DollarDiscTrans'
            }, {
                label: 'Item Dollar Discount',
                value: 'DollarDiscItem'
            },
        ],
        fleetAwardType: [
            {
                label: 'Item',
                value: 'Item'
            }, {
                label: 'Item Rate',
                value: 'ItemRate'
            },
        ],
        receiptItemType: [
            {
                label: 'Transaction Dollar Discount',
                value: 'DollarDiscTrans'
            }, {
                label: 'Item Dollar Discount',
                value: 'DollarDiscItem'
            }, {
                label: 'Time',
                value: 'Time'
            },
        ],
        billingCycle: [
            // {
            //     label: 'None',
            //     value: 0
            // },
            {
                label: 'Monthly',
                value: 1
            }, {
                label: 'Yearly',
                value: 12
            },
        ]
    },
    washClub: {
        period: [
            {
                label: 'Wash Club Default',
                value: 'UseDefault'
            }, {
                label: 'Unlimited',
                value: 'Unlimited'
            }, {
                label: 'Day',
                value: 'Day'
            }, {
                label: 'Month',
                value: 'Month'
            },
        ],
        status: [
            {
                label: 'Inactive',
                value: 'Inactive'
            }, {
                label: 'Active',
                value: 'Active'
            }, {
                label: 'End Billing Pending',
                value: 'EndBillingPending'
            },
            {
                label: 'Credit Hold',
                value: 'CreditHold',
                disabled: true
            },
            {
                label: 'Billing Hold',
                value: 'BillingHold',
                disabled: true
            },
            {
                label: 'Deleted',
                value: 'Deleted',
                disabled: true
            },
        ],
        allowUpgrades: [
            {
                label: 'Award Default',
                value: 'UseDefault'
            }, {
                label: 'Kiosk Default',
                value: 'KioskDefault'
            }, {
                label: 'Yes',
                value: 'True'
            }, {
                label: 'No',
                value: 'False'
            },
        ],
        boolAllowUpgrades: [
            {
                label: 'Award Default',
                value: 'UseDefault'
            }, {
                label: 'Kiosk Default',
                value: 'KioskDefault'
            }, {
                label: 'Yes',
                value: true
            }, {
                label: 'No',
                value: false
            },
        ],
        autoSelect: [
            {
                label: 'Award Default',
                value: 'UseDefault'
            }, {
                label: 'Kiosk Default',
                value: 'KioskDefault'
            }, {
                label: 'Yes',
                value: 'True'
            }, {
                label: 'No',
                value: 'False'
            },
        ],
        receiptMode: [
            {
                label: 'Loyalty Default',
                value: 'UseDefault'
            }, {
                label: 'Kiosk Default',
                value: 'KioskDefault'
            }, {
                label: 'Ask',
                value: 'Ask'
            }, {
                label: 'Always',
                value: 'Always'
            }, {
                label: 'Never',
                value: 'Never'
            },
        ],
        type: [
            {
                label: 'Monthly',
                // value: 13
                value: 'AppWashClub'
            },
            {
                label: 'Pay as you Go',
                // value: 5
                value: 'DailyPass'
            },
        ]
    },
    processors: [
        {
            label: 'E-xact',
            value: 'Exact',
            disabled: true
        }, {
            label: 'E-xact Hosted',
            value: 'ExactHosted'
        }, {
            label: 'ID TECH',
            value: 'IPS'
        }, {
            label: 'Moneris',
            value: 'Moneris'
        }, {
            label: 'Worldpay',
            value: 'Worldpay'
        },
    ],
    invoice: {
        status: [
            {
                label: 'Pending',
                value: 'Pending'
            }, {
                label: 'Canceled',
                value: 'Canceled'
            }, {
                label: 'Paid',
                value: 'Paid'
            },
        ],
        paymentType: [
            {
                label: 'Credit Card',
                value: 'CreditCard'
            }, {
                label: 'Cash',
                value: 'Cash'
            },
        ]
    },
    reports: {
        grouping: [
            {
                label: 'Hourly',
                value: 'Hour'
            }, {
                label: 'Daily',
                value: 'Day'
            }, {
                label: 'Weekly',
                value: 'Week'
            }, {
                label: 'Monthly',
                value: 'Month'
            }, {
                label: 'Yearly',
                value: 'Year'
            },
        ]
    },
    countries: [
        {
            label: 'United States',
            value: 'US'
        }, {
            label: 'Canada',
            value: 'CA'
        }, {
            label: 'Mexico',
            value: 'MX'
        }, {
            label: 'Australia',
            value: 'AU'
        }
    ],
    colorPreset: [
        {
            label: 'Blue',
            value: '#0076ff'
        },
        {
            label: 'Teal',
            value: '#00d3bc'
        },
        {
            label: 'Navy',
            value: '#03029f'
        },
        {
            label: 'Sky Blue',
            value: '#38d6ff'
        },
        {
            label: 'Green',
            value: '#7ed321'
        },
        {
            label: 'Magenta',
            value: '#a22193'
        },
        {
            label: 'Gray',
            value: '#a4aab3'
        },
        {
            label: 'Light Gray',
            value: '#c7c7cd'
        },
        {
            label: 'Pink',
            value: '#f8d1e8'
        },
        {
            label: 'Red',
            value: '#fe2851'
        },
        {
            label: 'Orange',
            value: '#ff8d11'
        },
        {
            label: 'Yellow',
            value: '#ffc300'
        }
    ],
    expirationType: [
        {
            label: "None",
            value: "None"
        },
        {
            label: "End Date",
            value: "EndDate"
        },
        {
            label: "Custom",
            value: "Custom"
        },
        {
            label: "Date",
            value: "Date"
        }
    ],
    productType: [
        {
            label: "Wash",
            value: "AppWash"
        },
        {
            label: "Bundle",
            value: "AppBundle"
        }
    ],
    fulfillmentType: [
        {
            label: "Gift Card",
            value: "GiftCard"
        },
        {
            label: "Gift Card Recharge",
            value: "GiftCardRecharge"
        },
        {
            label: "Merchandise",
            value: "Merchandise"
        }
    ],
    timeZones: [
        {
            "value": "Afghanistan Standard Time",
            "label": "(UTC+04:30) Kabul"
        },
        {
            "value": "Alaskan Standard Time",
            "label": "(UTC-09:00) Alaska"
        },
        {
            "value": "Arab Standard Time",
            "label": "(UTC+03:00) Kuwait, Riyadh"
        },
        {
            "value": "Arabian Standard Time",
            "label": "(UTC+04:00) Abu Dhabi, Muscat"
        },
        {
            "value": "Arabic Standard Time",
            "label": "(UTC+03:00) Baghdad"
        },
        {
            "value": "Argentina Standard Time",
            "label": "(UTC-03:00) Buenos Aires"
        },
        {
            "value": "Atlantic Standard Time",
            "label": "(UTC-04:00) Atlantic Time (Canada)"
        },
        {
            "value": "AUS Central Standard Time",
            "label": "(UTC+09:30) Darwin"
        },
        {
            "value": "AUS Eastern Standard Time",
            "label": "(UTC+10:00) Canberra, Melbourne, Sydney"
        },
        {
            "value": "Azerbaijan Standard Time",
            "label": "(UTC+04:00) Baku"
        },
        {
            "value": "Azores Standard Time",
            "label": "(UTC-01:00) Azores"
        },
        {
            "value": "Bahia Standard Time",
            "label": "(UTC-03:00) Salvador"
        },
        {
            "value": "Bangladesh Standard Time",
            "label": "(UTC+06:00) Dhaka"
        },
        {
            "value": "Canada Central Standard Time",
            "label": "(UTC-06:00) Saskatchewan"
        },
        {
            "value": "Cape Verde Standard Time",
            "label": "(UTC-01:00) Cape Verde Is."
        },
        {
            "value": "Caucasus Standard Time",
            "label": "(UTC+04:00) Yerevan"
        },
        {
            "value": "Cen. Australia Standard Time",
            "label": "(UTC+09:30) Adelaide"
        },
        {
            "value": "Central America Standard Time",
            "label": "(UTC-06:00) Central America"
        },
        {
            "value": "Central Asia Standard Time",
            "label": "(UTC+06:00) Astana"
        },
        {
            "value": "Central Brazilian Standard Time",
            "label": "(UTC-04:00) Cuiaba"
        },
        {
            "value": "Central Europe Standard Time",
            "label": "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague"
        },
        {
            "value": "Central European Standard Time",
            "label": "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb"
        },
        {
            "value": "Central Pacific Standard Time",
            "label": "(UTC+11:00) Solomon Is., New Caledonia"
        },
        {
            "value": "Central Standard Time",
            "label": "(UTC-06:00) Central Time (US & Canada)"
        },
        {
            "value": "Central Standard Time (Mexico)",
            "label": "(UTC-06:00) Guadalajara, Mexico City, Monterrey"
        },
        {
            "value": "China Standard Time",
            "label": "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi"
        },
        {
            "value": "Dateline Standard Time",
            "label": "(UTC-12:00) International Date Line West"
        },
        {
            "value": "E. Africa Standard Time",
            "label": "(UTC+03:00) Nairobi"
        },
        {
            "value": "E. Australia Standard Time",
            "label": "(UTC+10:00) Brisbane"
        },
        {
            "value": "E. South America Standard Time",
            "label": "(UTC-03:00) Brasilia"
        },
        {
            "value": "Eastern Standard Time",
            "label": "(UTC-05:00) Eastern Time (US & Canada)"
        },
        {
            "value": "Egypt Standard Time",
            "label": "(UTC+02:00) Cairo"
        },
        {
            "value": "Ekaterinburg Standard Time",
            "label": "(UTC+06:00) Ekaterinburg"
        },
        {
            "value": "Fiji Standard Time",
            "label": "(UTC+12:00) Fiji"
        },
        {
            "value": "FLE Standard Time",
            "label": "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius"
        },
        {
            "value": "Georgian Standard Time",
            "label": "(UTC+04:00) Tbilisi"
        },
        {
            "value": "GMT Standard Time",
            "label": "(UTC) Dublin, Edinburgh, Lisbon, London"
        },
        {
            "value": "Greenland Standard Time",
            "label": "(UTC-03:00) Greenland"
        },
        {
            "value": "Greenwich Standard Time",
            "label": "(UTC) Monrovia, Reykjavik"
        },
        {
            "value": "GTB Standard Time",
            "label": "(UTC+02:00) Athens, Bucharest"
        },
        {
            "value": "Hawaiian Standard Time",
            "label": "(UTC-10:00) Hawaii"
        },
        {
            "value": "India Standard Time",
            "label": "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi"
        },
        {
            "value": "Iran Standard Time",
            "label": "(UTC+03:30) Tehran"
        },
        {
            "value": "Israel Standard Time",
            "label": "(UTC+02:00) Jerusalem"
        },
        {
            "value": "Kaliningrad Standard Time",
            "label": "(UTC+03:00) Kaliningrad, Minsk"
        },
        {
            "value": "Kamchatka Standard Time",
            "label": "(UTC+12:00) Petropavlovsk-Kamchatsky - Old"
        },
        {
            "value": "Korea Standard Time",
            "label": "(UTC+09:00) Seoul"
        },
        {
            "value": "Magadan Standard Time",
            "label": "(UTC+12:00) Magadan"
        },
        {
            "value": "Mauritius Standard Time",
            "label": "(UTC+04:00) Port Louis"
        },
        {
            "value": "Mid-Atlantic Standard Time",
            "label": "(UTC-02:00) Mid-Atlantic"
        },
        {
            "value": "Middle East Standard Time",
            "label": "(UTC+02:00) Beirut"
        },
        {
            "value": "Montevideo Standard Time",
            "label": "(UTC-03:00) Montevideo"
        },
        {
            "value": "Morocco Standard Time",
            "label": "(UTC) Casablanca"
        },
        {
            "value": "Mountain Standard Time",
            "label": "(UTC-07:00) Mountain Time (US & Canada)"
        },
        {
            "value": "Mountain Standard Time (Mexico)",
            "label": "(UTC-07:00) Chihuahua, La Paz, Mazatlan"
        },
        {
            "value": "Myanmar Standard Time",
            "label": "(UTC+06:30) Yangon (Rangoon)"
        },
        {
            "value": "N. Central Asia Standard Time",
            "label": "(UTC+07:00) Novosibirsk"
        },
        {
            "value": "Namibia Standard Time",
            "label": "(UTC+01:00) Windhoek"
        },
        {
            "value": "Nepal Standard Time",
            "label": "(UTC+05:45) Kathmandu"
        },
        {
            "value": "New Zealand Standard Time",
            "label": "(UTC+12:00) Auckland, Wellington"
        },
        {
            "value": "Newfoundland Standard Time",
            "label": "(UTC-03:30) Newfoundland"
        },
        {
            "value": "North Asia East Standard Time",
            "label": "(UTC+09:00) Irkutsk"
        },
        {
            "value": "North Asia Standard Time",
            "label": "(UTC+08:00) Krasnoyarsk"
        },
        {
            "value": "Pacific SA Standard Time",
            "label": "(UTC-04:00) Santiago"
        },
        {
            "value": "Pacific Standard Time",
            "label": "(UTC-08:00) Pacific Time (US & Canada)"
        },
        {
            "value": "Pacific Standard Time (Mexico)",
            "label": "(UTC-08:00) Baja California"
        },
        {
            "value": "Pakistan Standard Time",
            "label": "(UTC+05:00) Islamabad, Karachi"
        },
        {
            "value": "Paraguay Standard Time",
            "label": "(UTC-04:00) Asuncion"
        },
        {
            "value": "Romance Standard Time",
            "label": "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris"
        },
        {
            "value": "Russian Standard Time",
            "label": "(UTC+04:00) Moscow, St. Petersburg, Volgograd"
        },
        {
            "value": "SA Eastern Standard Time",
            "label": "(UTC-03:00) Cayenne, Fortaleza"
        },
        {
            "value": "SA Pacific Standard Time",
            "label": "(UTC-05:00) Bogota, Lima, Quito"
        },
        {
            "value": "SA Western Standard Time",
            "label": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan"
        },
        {
            "value": "Samoa Standard Time",
            "label": "(UTC+13:00) Samoa"
        },
        {
            "value": "SE Asia Standard Time",
            "label": "(UTC+07:00) Bangkok, Hanoi, Jakarta"
        },
        {
            "value": "Singapore Standard Time",
            "label": "(UTC+08:00) Kuala Lumpur, Singapore"
        },
        {
            "value": "South Africa Standard Time",
            "label": "(UTC+02:00) Harare, Pretoria"
        },
        {
            "value": "Sri Lanka Standard Time",
            "label": "(UTC+05:30) Sri Jayawardenepura"
        },
        {
            "value": "Syria Standard Time",
            "label": "(UTC+02:00) Damascus"
        },
        {
            "value": "Taipei Standard Time",
            "label": "(UTC+08:00) Taipei"
        },
        {
            "value": "Tasmania Standard Time",
            "label": "(UTC+10:00) Hobart"
        },
        {
            "value": "Tokyo Standard Time",
            "label": "(UTC+09:00) Osaka, Sapporo, Tokyo"
        },
        {
            "value": "Tonga Standard Time",
            "label": "(UTC+13:00) Nuku'alofa"
        },
        {
            "value": "Turkey Standard Time",
            "label": "(UTC+02:00) Istanbul"
        },
        {
            "value": "Ulaanbaatar Standard Time",
            "label": "(UTC+08:00) Ulaanbaatar"
        },
        {
            "value": "US Eastern Standard Time",
            "label": "(UTC-05:00) Indiana (East)"
        },
        {
            "value": "US Mountain Standard Time",
            "label": "(UTC-07:00) Arizona"
        },
        {
            "value": "UTC",
            "label": "(UTC) Coordinated Universal Time"
        },
        {
            "value": "UTC+12",
            "label": "(UTC+12:00) Coordinated Universal Time+12"
        },
        {
            "value": "UTC-02",
            "label": "(UTC-02:00) Coordinated Universal Time-02"
        },
        {
            "value": "UTC-11",
            "label": "(UTC-11:00) Coordinated Universal Time-11"
        },
        {
            "value": "Venezuela Standard Time",
            "label": "(UTC-04:30) Caracas"
        },
        {
            "value": "Vladivostok Standard Time",
            "label": "(UTC+11:00) Vladivostok"
        },
        {
            "value": "W. Australia Standard Time",
            "label": "(UTC+08:00) Perth"
        },
        {
            "value": "W. Central Africa Standard Time",
            "label": "(UTC+01:00) West Central Africa"
        },
        {
            "value": "W. Europe Standard Time",
            "label": "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna"
        },
        {
            "value": "West Asia Standard Time",
            "label": "(UTC+05:00) Tashkent"
        },
        {
            "value": "West Pacific Standard Time",
            "label": "(UTC+10:00) Guam, Port Moresby"
        },
        {
            "value": "Yakutsk Standard Time",
            "label": "(UTC+10:00) Yakutsk"
        }
    ]
}